import { type SxProps, Typography } from '@mui/material';

interface Props {
  text: string;
  fontFamily?: string;
  sx?: SxProps;
}

export const MediumText = ({ text, fontFamily, sx }: Props) => {
  return (
    <Typography
      sx={{
        display: 'flex',
        alignSelf: 'center',
        ...sx,
      }}
      variant="medium"
      fontFamily={fontFamily ?? ''}
    >
      {text}
    </Typography>
  );
};
